<template>
  <page-header-wrapper>
    <div class="sales-order-page erp-list-page baidao-list-page baidao-list-sample sales-order-list-page">
      <div class="search-card erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="日期范围">
                <a-range-picker v-model="dateRange" style="width:100%" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单编号">
                <a-input v-model="query.orderNo" allow-clear placeholder="请输入订单编号" @pressEnter="loadData" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客商">
                <a-input v-model="query.customerKeyword" allow-clear placeholder="客商编号或名称" @pressEnter="loadData" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态">
                <a-select v-model="query.auditStatus" allow-clear placeholder="全部">
                  <a-select-option value="unaudited">未审核</a-select-option>
                  <a-select-option value="audited">已审核</a-select-option>
                  <a-select-option value="reverse_audited">已反审核</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单来源">
                <a-select v-model="query.orderSource" allow-clear placeholder="全部">
                  <a-select-option value="system">系统创建</a-select-option>
                  <a-select-option value="huazhu">华住推送</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态">
                <a-select v-model="query.hzOrderStatus" allow-clear placeholder="全部">
                  <a-select-option value="warehouse_accepted">仓库已接单</a-select-option>
                  <a-select-option value="shipped">已发货</a-select-option>
                  <a-select-option value="signed">已签收</a-select-option>
                  <a-select-option value="completed">已完成</a-select-option>
                  <a-select-option value="cancelled">已取消</a-select-option>
                  <a-select-option value="abnormal">异常</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="业务员">
                <a-select v-model="query.salesUserId" allow-clear show-search option-filter-prop="children" placeholder="全部业务员">
                  <a-select-option v-for="user in userOptions" :key="user.id" :value="user.id">{{ user.nickName || user.userName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="部门">
                <a-select v-model="query.deptId" allow-clear show-search option-filter-prop="children" placeholder="全部部门">
                  <a-select-option v-for="dept in departmentOptions" :key="dept.id" :value="dept.id">{{ dept.deptName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客商订单号">
                <a-input v-model="query.customerOrderNo" allow-clear placeholder="请输入客商订单号" @pressEnter="loadData" />
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24" class="search-actions erp-search-actions">
              <a-button type="primary" @click="loadData"><a-icon type="search" />查询</a-button>
              <a-button @click="resetQuery"><a-icon type="redo" />重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-card erp-table-card">
        <div class="table-toolbar erp-table-toolbar">
          <div>
            <h3>销售订单</h3>
            <p>本期仅处理普通销售订单，按单仓出库；B单待业务规则完善后开放。</p>
          </div>
          <div class="toolbar-actions erp-toolbar-actions"></div>
        </div>
        <a-table
          row-key="id"
          :columns="columns"
          :data-source="list"
          :loading="loading"
          :pagination="pagination"
          :row-class-name="outboundRowClass"
          :scroll="{ x: 2610 }"
          bordered
          size="middle"
          @change="handleTableChange"
        >
          <template slot="orderNo" slot-scope="text, record">
            <a @click="openDetail(record)">{{ text }}</a>
          </template>
          <template slot="auditStatus" slot-scope="text">
            <a-tag class="erp-status-tag" :color="auditColor(text)">{{ auditText(text) }}</a-tag>
          </template>
          <template slot="orderSource" slot-scope="text">
            <a-tag class="erp-status-tag" :color="orderSourceColor(text)">{{ orderSourceText(text) }}</a-tag>
          </template>
          <template slot="hzOrderStatus" slot-scope="text">
            <a-tag v-if="hzText(text) !== '—'" class="erp-status-tag" :color="hzColor(text)">{{ hzText(text) }}</a-tag>
            <span v-else>—</span>
          </template>
          <template slot="outboundStatus" slot-scope="text, record">
            <a-tag class="erp-status-tag" :color="outboundColor(record)">{{ outboundText(record) }}</a-tag>
          </template>
          <template slot="voidStatus" slot-scope="text">
            <a-tag v-if="text === 'voided'" color="red">已作废</a-tag>
            <span v-else>—</span>
          </template>
          <template slot="settlementMethod" slot-scope="text">
            {{ optionLabel(settlementMethodOptions, text) }}
          </template>
          <template slot="deliveryMethod" slot-scope="text">
            {{ optionLabel(deliveryMethodOptions, text) }}
          </template>
          <template slot="occupyStatus" slot-scope="text">
            {{ occupyText(text) }}
          </template>
          <template slot="amount" slot-scope="text">
            <span class="erp-money">¥{{ money(text) }}</span>
          </template>
          <template slot="amountOrEmpty" slot-scope="text">
            <span v-if="text !== null && text !== undefined" class="erp-money">¥{{ money(text) }}</span>
            <span v-else>—</span>
          </template>
          <template slot="salesUser" slot-scope="text">
            {{ userLabel(text) }}
          </template>
          <template slot="department" slot-scope="text, record">
            {{ text || deptLabel(record.deptId) }}
          </template>
          <template slot="emptyValue" slot-scope="text">
            {{ displayValue(text) }}
          </template>
          <template slot="attachment" slot-scope="text">
            <a-popover v-if="attachmentCount(text)" placement="bottomRight" trigger="click">
              <template slot="content"><div class="attachment-list"><a v-for="(url, index) in attachmentItems(text)" :key="url + index" :href="url" target="_blank"><a-icon type="paper-clip" /> 附件 {{ index + 1 }}</a></div></template>
              <a><a-icon type="paper-clip" /> {{ attachmentCount(text) }}</a>
            </a-popover>
            <span v-else>0</span>
          </template>
          <template slot="operation" slot-scope="text, record">
            <a v-if="record.auditStatus !== 'audited'" @click="openEdit(record)">编辑</a>
            <a v-else @click="openDetail(record)">查看</a>
            <template v-if="record.auditStatus !== 'audited' && record.voidStatus !== 'voided'">
              <a-divider type="vertical" />
              <a @click="handleAudit(record)">审核</a>
            </template>
          </template>
        </a-table>
      </div>

      <a-drawer
        :visible="drawerVisible"
        :width="drawerWidth"
        :closable="false"
        :body-style="{ padding: 0 }"
        :mask-closable="false"
        class="erp-doc-drawer baidao-drawer-sample sales-order-drawer"
        @close="closeDrawer"
      >
        <div class="erp-drawer-shell">
          <header class="erp-drawer-header">
            <div><button class="erp-back-button" type="button" title="返回销售订单列表" aria-label="返回销售订单列表" @click="closeDrawer"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">{{ readOnly ? '查看单据' : (form.id ? '编辑单据' : '新建单据') }}</span><h3>{{ form.orderNo || '新建销售订单' }}</h3></div>
            <div><a-button @click="closeDrawer">取消</a-button><a-button v-if="!readOnly" type="primary" :loading="saving" @click="saveForm">保存</a-button></div>
          </header>
          <div class="erp-drawer-content">
            <div class="erp-status-strip"><a-tag class="erp-status-tag" :color="auditColor(form.auditStatus)">{{ auditText(form.auditStatus) }}</a-tag><a-tag v-if="form.id && hzText(form.hzOrderStatus) !== '—'" class="erp-status-tag" :color="hzColor(form.hzOrderStatus)">{{ hzText(form.hzOrderStatus) }}</a-tag><a-tag v-if="form.id" class="erp-status-tag" :color="outboundColor(form)">{{ outboundText(form) }}</a-tag><span v-if="form.auditStatus === 'audited'">订单已审核；库存充足时已自动出库，不足时请手动创建销售出库单。</span><span v-else-if="form.auditStatus === 'reverse_audited'">库存占用已释放；可修正后重新审核。</span><span v-else>保存仅生成未审核订单；审核后占用可用库存，充足时自动出库。</span></div>
            <a-form-model ref="formRef" :model="form" :rules="rules" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
              <section class="erp-form-card">
                <div class="erp-section-title"><span class="erp-section-index">01</span><div><h4>基础信息</h4><p>先确定客户与出货仓，再从该仓价格体系选择商品</p></div></div>
                <a-row :gutter="24">
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="订单类型"><a-input value="销售订单" disabled /></a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="订单来源">
                      <a-input :value="orderSourceText(form.orderSource)" disabled />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="销售订单类型">
                      <a-select v-model="form.saleOrderKind" disabled>
                        <a-select-option value="normal_order">正常订单</a-select-option>
                        <a-select-option value="abnormal_order">异常订单</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-if="form.saleOrderKind === 'abnormal_order'" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="异常原因">
                      <a-input v-model="form.abnormalReason" :disabled="readOnly" placeholder="请输入异常原因" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="订单状态">
                      <a-input :value="hzText(form.hzOrderStatus)" disabled />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="订单编号">
                      <a-input v-model="form.orderNo" :disabled="readOnly" placeholder="保存后系统自动生成，可手动录入" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="单据日期" prop="orderDate">
                      <a-date-picker v-model="form.orderDate" :disabled="readOnly" style="width:100%" value-format="YYYY-MM-DD" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="客商订单号">
                      <a-input v-model="form.customerOrderNo" :disabled="readOnly" placeholder="选填，录入客户外部订单号" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="客户编号" prop="customerId">
                      <a-input-search
                        v-model="form.customerCode"
                        read-only
                        :disabled="readOnly"
                        enter-button="选择"
                        placeholder="请选择客户"
                        @click="openCustomerPicker"
                        @search="openCustomerPicker"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="客户名称" prop="customerName">
                      <a-input-search
                        v-model="form.customerName"
                        read-only
                        :disabled="readOnly"
                        enter-button="选择"
                        placeholder="请选择客户"
                        @click="openCustomerPicker"
                        @search="openCustomerPicker"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="出货仓库" prop="deliveryWarehouseId">
                      <a-select
                        v-model="form.deliveryWarehouseId"
                        show-search
                        :disabled="readOnly"
                        option-filter-prop="children"
                        style="width:100%"
                        placeholder="请选择启用仓库"
                        @change="onWarehouseChange"
                      >
                        <a-select-option v-for="warehouse in warehouses" :key="warehouse.id" :value="warehouse.id">
                          {{ warehouse.warehouseCode }} · {{ warehouse.warehouseName }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="结算方式">
                      <a-select v-model="form.settlementMethod" disabled placeholder="选择客户后自动带出">
                        <a-select-option v-for="option in settlementMethodOptions" :key="option.value" :value="option.value">{{ option.label }}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="送货方式">
                      <a-select v-model="form.deliveryMethod" :disabled="readOnly" allow-clear placeholder="请选择">
                        <a-select-option v-for="option in deliveryMethodOptions" :key="option.value" :value="option.value">{{ option.label }}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="业务员">
                      <a-select
                        v-model="form.salesUserId"
                        :disabled="readOnly"
                        allow-clear
                        show-search
                        option-filter-prop="children"
                        placeholder="请选择业务员">
                        <a-select-option v-for="user in userOptions" :key="user.id" :value="user.id">{{ user.nickName || user.userName }}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="部门">
                      <a-select
                        v-model="form.deptId"
                        :disabled="readOnly"
                        allow-clear
                        show-search
                        option-filter-prop="children"
                        placeholder="请选择部门">
                        <a-select-option v-for="dept in departmentOptions" :key="dept.id" :value="dept.id">{{ dept.deptName }}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="整单折扣金额">
                      <a-input-number v-model="form.wholeDiscountAmount" :disabled="readOnly" :min="0" :precision="2" style="width:100%" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="运费">
                      <a-input-number
                        v-model="form.freightAmount"
                        :disabled="readOnly"
                        :min="0"
                        :precision="2"
                        style="width:100%"
                        placeholder="请输入" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <a-form-model-item label="期望送达日期">
                      <a-date-picker
                        v-model="form.expectedDeliveryDate"
                        :disabled="readOnly"
                        style="width:100%"
                        value-format="YYYY-MM-DD"
                        placeholder="请选择日期" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="24">
                    <a-form-model-item label="附件" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                      <file-upload
                        :value="form.attachmentUrl || ''"
                        type="file"
                        field-name="attachmentUrl"
                        :count="3"
                        :disabled="readOnly"
                        @change="attachmentChanged" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </section>

              <section class="erp-form-card">
                <div class="erp-section-heading-row">
                  <div class="erp-section-title"><span class="erp-section-index">02</span><div><h4>商品明细</h4><p>{{ form.deliveryWarehouseId ? `仅可选择已在${selectedWarehouseText}完成仓库配置的 SKU` : '请先选择出货仓库' }}</p></div></div>
                  <a-button v-if="!readOnly" size="small" type="primary" ghost @click="openProductPicker">
                    <a-icon type="plus" />选择商品
                  </a-button>
                </div>
                <div class="erp-line-table-wrap item-table-wrap">
                  <table class="erp-line-table item-table">
                    <thead>
                      <tr>
                        <th>商品 / SKU</th>
                        <th>SKU编码</th>
                        <th>单位</th>
                        <th>数量</th>
                        <th>销售指导价</th>
                        <th>单价</th>
                        <th>税率%</th>
                        <th>金额</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in form.items" :key="item.skuId || index" :class="{ 'item-row-error': item.priceError }">
                        <td class="order-product-cell">
                          <strong>{{ item.skuName || '未命名 SKU' }}</strong>
                          <span>{{ item.spuName || item.specName || '来自商品档案' }}</span>
                        </td>
                        <td><a-input :value="item.skuCode" size="small" disabled /></td>
                        <td><a-input :value="item.unitName" size="small" disabled /></td>
                        <td><a-input-number
                          v-model="item.qtyOrder"
                          :disabled="readOnly"
                          :min="0"
                          :precision="3"
                          size="small"
                          style="width:100%" /></td>
                        <td>
                          <a-select
                            v-model="item.guidePriceId"
                            size="small"
                            style="width:180px"
                            :loading="item.guidePriceLoading"
                            :disabled="readOnly || item.guidePrices.length <= 1"
                            :placeholder="item.guidePrices.length ? '请选择指导价' : '未设指导价（直接录入单价）'"
                            @change="selectGuidePrice(item)"
                          >
                            <a-select-option v-for="price in item.guidePrices" :key="String(price.id)" :value="String(price.id)">
                              {{ price.guidePriceName }} · ¥{{ money(guideOptionUnitPrice(price)) }}
                            </a-select-option>
                          </a-select>
                          <span v-if="item.priceError" class="item-price-error">
                            <a-icon type="exclamation-circle" />{{ item.priceError }}
                          </span>
                        </td>
                        <td>
                          <a-input-number
                            v-model="item.salePrice"
                            :min="0"
                            :precision="2"
                            size="small"
                            style="width:100%"
                            :disabled="readOnly || (item.guidePrices.length > 0 && !!item.guidePriceId)"
                          />
                        </td>
                        <td><a-input-number
                          v-model="item.taxRate"
                          :disabled="readOnly"
                          :min="0"
                          :precision="2"
                          size="small"
                          style="width:100%" /></td>
                        <td><span class="erp-money">¥{{ lineAmount(item) }}</span></td>
                        <td><a v-if="!readOnly" class="erp-danger-link" @click="removeItem(index)">删除</a><span v-else>—</span></td>
                      </tr>
                      <tr v-if="!form.items.length">
                        <td colspan="9" class="item-empty">
                          <a-icon type="inbox" />
                          <span>暂未选择商品，请点击“选择商品”从商品档案添加</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
              <section class="erp-form-card">
                <div class="erp-section-title"><span class="erp-section-index">03</span><div><h4>备注</h4><p>记录订单补充说明或特殊履约要求</p></div></div>
                <a-textarea v-model="form.remark" :disabled="readOnly" :rows="3" placeholder="请输入备注" />
              </section>
            </a-form-model>
          </div>
          <div v-if="drawerVisible" class="erp-drawer-footer">
            <div class="total-summary"><span>金额 <b>¥{{ totalAmount }}</b></span><span>税额 <b>¥{{ totalTaxAmountOnly }}</b></span><span>价税合计 <b>¥{{ totalWithTax }}</b></span><span>整单折扣 <b>¥{{ discountAmount }}</b></span><span>折后实际金额 <strong>¥{{ actualAmount }}</strong></span></div>
            <div><a-button @click="closeDrawer">返回列表</a-button><a-button v-if="!readOnly" type="primary" :loading="saving" @click="saveForm">保存订单</a-button></div>
          </div>
        </div>
      </a-drawer>

      <a-modal
        title="选择客户"
        :visible="customerPicker.visible"
        width="1040px"
        class="erp-picker-modal customer-picker-modal"
        :body-style="{ padding: '18px 20px 12px' }"
        :confirm-loading="customerPicker.loading"
        ok-text="确定选择"
        cancel-text="取消"
        @ok="confirmCustomerPicker"
        @cancel="customerPicker.visible = false"
      >
        <div class="customer-picker-panel">
          <div class="customer-picker-search">
            <label class="customer-picker-field">
              <span>客户编号</span>
              <a-input
                v-model="customerPicker.query.customerCode"
                allow-clear
                placeholder="请输入客户编号"
                @pressEnter="searchCustomerOptions"
              />
            </label>
            <label class="customer-picker-field">
              <span>客户名称</span>
              <a-input
                v-model="customerPicker.query.customerName"
                allow-clear
                placeholder="请输入客户名称"
                @pressEnter="searchCustomerOptions"
              />
            </label>
            <div class="customer-picker-actions">
              <a-button type="primary" @click="searchCustomerOptions"><a-icon type="search" />查询</a-button>
              <a-button @click="resetCustomerPicker"><a-icon type="redo" />重置</a-button>
            </div>
          </div>
          <div class="customer-picker-tip">
            <span><a-icon type="info-circle" /> 单击行选择，双击行直接确认</span>
            <span v-if="customerPicker.selectedCustomer" class="selected-customer">
              <a-icon type="check-circle" /> 已选：{{ customerPicker.selectedCustomer.customerCode || '无编号' }} / {{ customerPicker.selectedCustomer.customerName || '未命名客户' }}
            </span>
          </div>
        </div>
        <a-table
          row-key="id"
          size="small"
          bordered
          :columns="customerColumns"
          :data-source="customerPicker.list"
          :loading="customerPicker.loading"
          :pagination="customerPicker.pagination"
          :row-selection="customerRowSelection"
          :scroll="{ x: 920, y: 360 }"
          :row-class-name="customerRowClassName"
          :locale="{ emptyText: '暂无符合条件的启用客户' }"
          @change="handleCustomerTableChange"
          @row="customerRowEvents"
        >
          <template slot="customerCode" slot-scope="text">
            <span class="customer-code">{{ text || '—' }}</span>
          </template>
          <template slot="customerName" slot-scope="text">
            <span class="customer-name">{{ text || '未命名客户' }}</span>
          </template>
          <template slot="merchantType" slot-scope="text">
            {{ merchantTypeText(text) }}
          </template>
          <template slot="customerNature" slot-scope="text">
            {{ customerNatureText(text) }}
          </template>
          <template slot="mobile" slot-scope="text">
            {{ text || '—' }}
          </template>
          <template slot="status" slot-scope="text">
            <a-tag class="erp-status-tag" :color="text === 'disabled' ? 'default' : 'green'">{{ text === 'disabled' ? '停用' : '启用' }}</a-tag>
          </template>
        </a-table>
      </a-modal>

      <a-modal
        title="选择商品"
        :visible="productPicker.visible"
        width="1120px"
        class="erp-picker-modal product-picker-modal"
        :body-style="{ padding: '18px 20px 12px' }"
        :confirm-loading="productPicker.loading"
        ok-text="添加到订单"
        cancel-text="取消"
        @ok="confirmProductPicker"
        @cancel="productPicker.visible = false"
      >
        <div class="product-picker-panel">
          <div class="product-picker-search">
            <label class="product-picker-field">
              <span>商品关键字</span>
              <a-input
                v-model="productPicker.keyword"
                allow-clear
                placeholder="商品名称、商品编码、SKU编码、规格或条形码"
                @pressEnter="searchProductOptions"
              />
            </label>
            <div class="product-picker-actions">
              <a-button type="primary" @click="searchProductOptions"><a-icon type="search" />查询</a-button>
              <a-button @click="resetProductPicker"><a-icon type="redo" />重置</a-button>
            </div>
          </div>
          <div class="product-picker-tip">
            <span><a-icon type="info-circle" /> 当前出货仓：{{ selectedWarehouseText }}；仅显示已在{{ selectedWarehouseText }}完成仓库配置的启用商品</span>
            <span class="selected-product-count"><a-icon type="check-circle" /> 已选 {{ productPicker.selectedRowKeys.length }} 个 SKU</span>
          </div>
        </div>
        <a-table
          row-key="id"
          size="small"
          bordered
          :columns="productColumns"
          :data-source="productPicker.list"
          :loading="productPicker.loading"
          :pagination="false"
          :row-selection="productRowSelection"
          :scroll="{ x: 1000, y: 400 }"
          :row-class-name="productRowClassName"
          :locale="{ emptyText: `暂无可用商品，请先在商品档案中为${selectedWarehouseText}维护仓库配置` }"
        >
          <template slot="spu" slot-scope="text, record">
            <div class="picker-product-main">
              <strong>{{ record.spuName || record.skuName || '未命名商品' }}</strong>
              <span>{{ record.spuCode || '无商品编码' }}</span>
            </div>
          </template>
          <template slot="sku" slot-scope="text, record">
            <div class="picker-product-main">
              <strong>{{ record.skuName || '未命名 SKU' }}</strong>
              <span>{{ record.skuCode || '无 SKU 编码' }}</span>
            </div>
          </template>
          <template slot="spec" slot-scope="text, record">
            {{ record.saleSpec || record.specName || '—' }}
          </template>
          <template slot="baseUnitName" slot-scope="text">
            {{ text || '—' }}
          </template>
          <template slot="categoryName" slot-scope="text">
            {{ text || '未分类' }}
          </template>
          <template slot="brandName" slot-scope="text">
            {{ text || '—' }}
          </template>
        </a-table>
      </a-modal>
    </div>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { pageCustomer, getCustomer } from '@/api/erp/customer'
import { listGuidePrice } from '@/api/erp/guidePrice'
import { listWarehouse } from '@/api/erp/warehouse'
import { pageUser } from '@/api/system/user'
import { listDept } from '@/api/system/dept'
import { getDicts } from '@/api/system/dict/data'
import {
  auditSalesOrder,
  createSalesOrder,
  deleteSalesOrder,
  getSalesOrder,
  guidePriceOptions,
  skuOptions,
  pageSalesOrder,
  reverseAuditSalesOrder,
  voidWholeSalesOrder,
  updateSalesOrder
} from '@/api/erp/salesOrder'

function defaultItem () {
  return {
    skuId: undefined,
    spuId: undefined,
    spuCode: '',
    spuName: '',
    skuCode: '',
    skuName: '',
    specName: '',
    saleSpec: '',
    barcode: '',
    categoryName: '',
    brandName: '',
    unitId: undefined,
    unitName: '斤',
    convertRateToBase: 1,
    qtyOrder: 1,
    guidePriceId: undefined,
    guidePriceName: '',
    guidePrices: [],
    guidePriceLoading: false,
    priceError: '',
    salePrice: 0,
    taxRate: 0
  }
}

function defaultForm () {
  return {
    id: undefined,
    orderNo: '',
    orderType: 'normal_sales',
    saleOrderKind: 'normal_order',
    orderSource: 'system',
    hzOrderStatus: '',
    abnormalReason: '',
    orderDate: moment().format('YYYY-MM-DD'),
    operatingSubjectId: 0,
    customerId: undefined,
    customerCode: '',
    customerName: '',
    deliveryWarehouseId: undefined,
    settlementMethod: undefined,
    salesUserId: undefined,
    deptId: undefined,
    wholeDiscountAmount: 0,
    freightAmount: undefined,
    expectedDeliveryDate: undefined,
    customerOrderNo: '',
    deliveryMethod: undefined,
    attachmentUrl: '',
    remark: '',
    items: []
  }
}

export default {
  name: 'ErpSalesOrder',
  data () {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      readOnly: false,
      viewportWidth: window.innerWidth,
      form: defaultForm(),
      dateRange: [],
      query: {
        orderNo: '',
        orderType: 'normal_sales',
        customerKeyword: '',
        auditStatus: undefined,
        orderSource: undefined,
        hzOrderStatus: undefined,
        salesUserId: undefined,
        deptId: undefined,
        customerOrderNo: ''
      },
      customerPicker: {
        visible: false,
        loading: false,
        selectedRowKeys: [],
        selectedCustomer: null,
        query: {
          customerCode: '',
          customerName: ''
        },
        list: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showTotal: (total, range) => `${range[0]}-${range[1]} / 共 ${total} 条`,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ['10', '20', '50']
        }
      },
      productPicker: {
        visible: false,
        loading: false,
        keyword: '',
        list: [],
        selectedRowKeys: [],
        selectedProducts: []
      },
      list: [],
      warehouses: [],
      userOptions: [],
      departmentOptions: [],
      settlementMethodOptions: [],
      deliveryMethodOptions: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true
      },
      columns: [
        { title: '日期', dataIndex: 'orderDate', width: 120, fixed: 'left' },
        { title: '编号', dataIndex: 'orderNo', width: 190, fixed: 'left', scopedSlots: { customRender: 'orderNo' } },
        { title: '客商编号', dataIndex: 'customerCode', width: 145, scopedSlots: { customRender: 'emptyValue' } },
        { title: '客商名称', dataIndex: 'customerName', width: 180, scopedSlots: { customRender: 'emptyValue' } },
        { title: '结算金额', dataIndex: 'totalTaxAmount', width: 125, scopedSlots: { customRender: 'amount' } },
        { title: '无税金额', dataIndex: 'totalAmount', width: 125, scopedSlots: { customRender: 'amount' } },
        { title: '整单折扣', dataIndex: 'wholeDiscountAmount', width: 115, scopedSlots: { customRender: 'amountOrEmpty' } },
        { title: '折后实际金额', dataIndex: 'actualAmount', width: 145, scopedSlots: { customRender: 'amount' } },
        { title: '客商订单号', dataIndex: 'customerOrderNo', width: 155, scopedSlots: { customRender: 'emptyValue' } },
        { title: '结算方式', dataIndex: 'settlementMethod', width: 120, scopedSlots: { customRender: 'settlementMethod' } },
        { title: '审核状态', dataIndex: 'auditStatus', width: 110, scopedSlots: { customRender: 'auditStatus' } },
        { title: '订单来源', dataIndex: 'orderSource', width: 110, scopedSlots: { customRender: 'orderSource' } },
        { title: '订单状态', dataIndex: 'hzOrderStatus', width: 120, scopedSlots: { customRender: 'hzOrderStatus' } },
        { title: '作废', dataIndex: 'voidStatus', width: 90, scopedSlots: { customRender: 'voidStatus' } },
        { title: '送货方式', dataIndex: 'deliveryMethod', width: 120, scopedSlots: { customRender: 'deliveryMethod' } },
        { title: '备注', dataIndex: 'remark', width: 180, ellipsis: true, scopedSlots: { customRender: 'emptyValue' } },
        { title: '操作', dataIndex: 'operation', width: 140, fixed: 'right', scopedSlots: { customRender: 'operation' } }
      ],
      customerColumns: [
        { title: '客户编号', dataIndex: 'customerCode', width: 150, scopedSlots: { customRender: 'customerCode' } },
        { title: '客户名称', dataIndex: 'customerName', width: 240, scopedSlots: { customRender: 'customerName' } },
        { title: '客户类型', dataIndex: 'merchantType', width: 120, scopedSlots: { customRender: 'merchantType' } },
        { title: '客户性质', dataIndex: 'customerNature', width: 120, scopedSlots: { customRender: 'customerNature' } },
        { title: '手机号', dataIndex: 'mobile', width: 140, scopedSlots: { customRender: 'mobile' } },
        { title: '状态', dataIndex: 'status', width: 90, align: 'center', scopedSlots: { customRender: 'status' } }
      ],
      productColumns: [
        { title: '商品', dataIndex: 'spuName', width: 220, scopedSlots: { customRender: 'spu' } },
        { title: 'SKU', dataIndex: 'skuName', width: 230, scopedSlots: { customRender: 'sku' } },
        { title: '规格', dataIndex: 'specName', width: 150, scopedSlots: { customRender: 'spec' } },
        { title: '基本单位', dataIndex: 'baseUnitName', width: 90, scopedSlots: { customRender: 'baseUnitName' } },
        { title: '商品分类', dataIndex: 'categoryName', width: 140, scopedSlots: { customRender: 'categoryName' } },
        { title: '品牌', dataIndex: 'brandName', width: 120, scopedSlots: { customRender: 'brandName' } }
      ],
      rules: {
        orderType: [{ required: true, message: '请选择订单类型' }],
        orderDate: [{ required: true, message: '请选择单据日期' }],
        customerId: [{ required: true, message: '请选择客户' }],
        customerName: [{ required: true, message: '请选择客户' }],
        deliveryWarehouseId: [{ required: true, message: '请选择出货仓库' }]
      }
    }
  },
  computed: {
    customerRowSelection () {
      return {
        type: 'radio',
        selectedRowKeys: this.customerPicker.selectedRowKeys,
        onChange: this.handleCustomerSelectionChange
      }
    },
    productRowSelection () {
      return {
        selectedRowKeys: this.productPicker.selectedRowKeys,
        onChange: this.handleProductSelectionChange
      }
    },
    drawerTitle () {
      return this.form.id ? '编辑销售订单' : '新建销售订单'
    },
    drawerWidth () {
      return this.viewportWidth < 1100 ? '100%' : '88%'
    },
    selectedWarehouseText () {
      const warehouse = this.warehouses.find(item => String(item.id) === String(this.form.deliveryWarehouseId))
      return warehouse ? `${warehouse.warehouseCode} · ${warehouse.warehouseName}` : '所选仓库'
    },
    totalAmount () {
      return this.money(this.form.items.reduce((sum, item) => sum + Number(this.lineAmount(item)), 0))
    },
    totalTaxAmountOnly () {
      const value = this.form.items.reduce((sum, item) => {
        const amount = Number(this.lineAmount(item))
        return sum + amount * Number(item.taxRate || 0) / 100
      }, 0)
      return this.money(value)
    },
    totalWithTax () {
      return this.money(Number(this.totalAmount) + Number(this.totalTaxAmountOnly))
    },
    discountAmount () {
      return this.money(this.form.wholeDiscountAmount)
    },
    actualAmount () {
      return this.money(Math.max(0, Number(this.totalWithTax) - Number(this.discountAmount)))
    }
  },
  created () {
    this.loadData()
    this.loadWarehouses()
    this.loadUsers()
    this.loadDepartments()
    this.loadBaseOptions()
    window.addEventListener('resize', this.updateViewport)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateViewport)
  },
  methods: {
    updateViewport () {
      this.viewportWidth = window.innerWidth
    },
    closeDrawer () {
      this.drawerVisible = false
    },
    loadWarehouses () {
      listWarehouse(true).then(res => { this.warehouses = res.data || [] })
    },
    loadUsers () {
      pageUser({ pageNum: 1, pageSize: 500, status: 1 }).then(res => {
        this.userOptions = (res.data && res.data.records) || []
      }).catch(() => { this.userOptions = [] })
    },
    loadDepartments () {
      listDept({ status: 1 }).then(res => { this.departmentOptions = res.data || [] }).catch(() => { this.departmentOptions = [] })
    },
    loadBaseOptions () {
      const mapOptions = res => (res.data || []).map(item => ({ value: item.dictValue, label: item.dictLabel }))
      getDicts('erp_settlement_method').then(res => { this.settlementMethodOptions = mapOptions(res) })
      getDicts('erp_delivery_method').then(res => { this.deliveryMethodOptions = mapOptions(res) })
    },
    loadData () {
      this.loading = true
      pageSalesOrder({
        ...this.query,
        dateStart: this.dateRange[0] && this.dateRange[0].format('YYYY-MM-DD'),
        dateEnd: this.dateRange[1] && this.dateRange[1].format('YYYY-MM-DD'),
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        const data = res.data || {}
        this.list = data.records || []
        this.pagination.total = Number(data.total || 0)
        this.pagination.current = Number(data.current || this.pagination.current)
      }).finally(() => {
        this.loading = false
      })
    },
    resetQuery () {
      this.query = { orderNo: '', orderType: 'normal_sales', customerKeyword: '', auditStatus: undefined, orderSource: undefined, hzOrderStatus: undefined, salesUserId: undefined, deptId: undefined, customerOrderNo: '' }
      this.dateRange = []
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    handleCustomerSelectionChange (selectedRowKeys, selectedRows) {
      this.customerPicker.selectedRowKeys = selectedRowKeys
      this.customerPicker.selectedCustomer = selectedRows[0] || null
    },
    openCustomerPicker () {
      this.customerPicker.visible = true
      this.customerPicker.selectedRowKeys = this.form.customerId ? [this.form.customerId] : []
      this.customerPicker.selectedCustomer = this.form.customerId
        ? {
            id: this.form.customerId,
            customerCode: this.form.customerCode,
            customerName: this.form.customerName
          }
        : null
      this.loadCustomerOptions()
    },
    loadCustomerOptions () {
      this.customerPicker.loading = true
      pageCustomer({
        customerCode: this.customerPicker.query.customerCode,
        customerName: this.customerPicker.query.customerName,
        status: 'enabled',
        pageNum: this.customerPicker.pagination.current,
        pageSize: this.customerPicker.pagination.pageSize
      }).then(res => {
        const data = res.data || {}
        this.customerPicker.list = data.records || []
        this.customerPicker.pagination.total = Number(data.total || 0)
        this.customerPicker.pagination.current = Number(data.current || this.customerPicker.pagination.current)
      }).finally(() => {
        this.customerPicker.loading = false
      })
    },
    searchCustomerOptions () {
      this.customerPicker.pagination.current = 1
      this.loadCustomerOptions()
    },
    resetCustomerPicker () {
      this.customerPicker.query = { customerCode: '', customerName: '' }
      this.customerPicker.pagination.current = 1
      this.loadCustomerOptions()
    },
    handleCustomerTableChange (pagination) {
      const pageSizeChanged = pagination.pageSize !== this.customerPicker.pagination.pageSize
      this.customerPicker.pagination.current = pagination.current
      this.customerPicker.pagination.pageSize = pagination.pageSize
      if (pageSizeChanged) this.customerPicker.pagination.current = 1
      this.loadCustomerOptions()
    },
    customerRowEvents (record) {
      return {
        on: {
          click: () => {
            this.customerPicker.selectedRowKeys = [record.id]
            this.customerPicker.selectedCustomer = record
          },
          dblclick: () => {
            this.customerPicker.selectedRowKeys = [record.id]
            this.customerPicker.selectedCustomer = record
            this.confirmCustomerPicker()
          }
        }
      }
    },
    customerRowClassName (record) {
      return this.customerPicker.selectedRowKeys.includes(record.id) ? 'customer-row-selected' : ''
    },
    merchantTypeText (value) {
      return ({
        direct: '直营店',
        direct_store: '直营店',
        franchise: '加盟店',
        franchise_store: '加盟店',
        ka: 'KA客户',
        community_store: '社区店',
        group_meal: '团餐客户',
        chain_hotel: '连锁酒店',
        distributor: '分销商',
        manufacturer: '直营店',
        dealer: '经销商',
        distribution: '分销客户',
        warehouse: '仓配客户'
      })[value] || value || '—'
    },
    customerNatureText (value) {
      return ({
        trade: '贸易',
        self: '自营',
        warehouse_distribution: '仓配一体化',
        all: '全部',
        mixed: '混合'
      })[value] || value || '—'
    },
    confirmCustomerPicker () {
      const customer = this.customerPicker.selectedCustomer
      if (!customer || !customer.id) {
        this.$message.warning('请选择一个客户')
        return
      }
      this.form.customerId = customer.id
      this.form.customerCode = customer.customerCode || ''
      this.form.customerName = customer.customerName || ''
      this.syncCustomerSettlementMethod(customer)
      this.customerPicker.visible = false
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField(['customerId', 'customerName'])
      })
    },
    resolveSettlementValue (val) {
      if (!val) return undefined
      if (this.settlementMethodOptions.some(o => o.value === val)) return val
      const found = this.settlementMethodOptions.find(o => o.label === val)
      if (found) return found.value
      const map = {
        '现结': 'cash',
        '账期': 'account_period',
        '预付款': 'prepayment',
        '批结': 'batch_settlement',
        '月清': 'monthly_clear'
      }
      return map[val] || val
    },
    syncCustomerSettlementMethod (customer) {
      if (!customer || !customer.id) return
      const extra = customer.extraFields || {}
      const directMethod = extra['结算方式'] || customer.settlementMethod
      if (directMethod) {
        this.form.settlementMethod = this.resolveSettlementValue(directMethod)
        return
      }
      getCustomer(customer.id).then(res => {
        const detail = res.data || {}
        const detailExtra = detail.extraFields || {}
        const method = detailExtra['结算方式'] || detail.settlementMethod
        if (method) {
          this.form.settlementMethod = this.resolveSettlementValue(method)
        }
      }).catch(() => {})
    },
    openAdd () {
      this.form = defaultForm()
      this.readOnly = false
      this.drawerVisible = true
      this.loadWarehouses()
    },
    openEdit (record) {
      this.readOnly = false
      this.loadWarehouses()
      getSalesOrder(record.id).then(res => {
        this.form = this.normalizeForm(res.data || {})
        this.drawerVisible = true
        this.form.items.forEach(item => {
          this.loadGuidePrices(item, true)
        })
      })
    },
    openDetail (record) {
      this.readOnly = true
      this.loadWarehouses()
      getSalesOrder(record.id).then(res => {
        this.form = this.normalizeForm(res.data || {})
        this.drawerVisible = true
        this.form.items.forEach(item => this.loadGuidePrices(item, true))
      })
    },
    normalizeForm (data) {
      return {
        ...defaultForm(),
        ...data,
        orderDate: data.orderDate || moment().format('YYYY-MM-DD'),
        saleOrderKind: data.saleOrderKind === 'abnormal_order' ? 'abnormal_order' : 'normal_order',
        orderSource: data.orderSource === 'huazhu' ? 'huazhu' : 'system',
        abnormalReason: data.abnormalReason || '',
        freightAmount: data.freightAmount == null || data.freightAmount === '' ? undefined : Number(data.freightAmount),
        expectedDeliveryDate: data.expectedDeliveryDate || undefined,
        items: (data.items || []).map(item => ({
          ...defaultItem(),
          ...item,
          qtyOrder: item.qtyOrder == null ? 1 : Number(item.qtyOrder),
          salePrice: item.salePrice == null ? 0 : Number(item.salePrice),
          taxRate: item.taxRate == null ? 0 : Number(item.taxRate)
        }))
      }
    },
    openProductPicker () {
      if (!this.form.deliveryWarehouseId) {
        this.$message.warning('请先选择出货仓库，再从商品档案选择商品')
        return
      }
      this.productPicker.keyword = ''
      const validItems = this.form.items.filter(item => !item.priceError)
      this.productPicker.selectedRowKeys = validItems.map(item => item.skuId).filter(Boolean)
      this.productPicker.selectedProducts = validItems.map(item => ({
        id: item.skuId,
        spuId: item.spuId,
        spuCode: item.spuCode,
        spuName: item.spuName,
        skuCode: item.skuCode,
        skuName: item.skuName,
        specName: item.specName,
        saleSpec: item.saleSpec,
        barcode: item.barcode,
        baseUnitId: item.unitId,
        baseUnitName: item.unitName,
        categoryName: item.categoryName,
        brandName: item.brandName
      }))
      this.productPicker.visible = true
      this.loadProductOptions()
    },
    loadProductOptions () {
      this.productPicker.loading = true
      skuOptions(this.productPicker.keyword, this.form.deliveryWarehouseId).then(res => {
        this.productPicker.list = res.data || []
        this.productPicker.list.forEach(product => {
          if (this.productPicker.selectedRowKeys.some(key => String(key) === String(product.id))) {
            this.syncProductSelection(product, true)
          }
        })
      }).finally(() => {
        this.productPicker.loading = false
      })
    },
    searchProductOptions () {
      this.loadProductOptions()
    },
    resetProductPicker () {
      this.productPicker.keyword = ''
      this.loadProductOptions()
    },
    handleProductSelectionChange (selectedRowKeys, selectedRows) {
      const productMap = {}
      this.productPicker.selectedProducts.forEach(product => { productMap[String(product.id)] = product })
      selectedRows.forEach(product => { productMap[String(product.id)] = product })
      this.productPicker.selectedRowKeys = selectedRowKeys
      this.productPicker.selectedProducts = selectedRowKeys
        .map(key => productMap[String(key)])
        .filter(Boolean)
    },
    syncProductSelection (record, selected) {
      const id = record.id
      const keyIndex = this.productPicker.selectedRowKeys.findIndex(key => String(key) === String(id))
      const productIndex = this.productPicker.selectedProducts.findIndex(item => String(item.id) === String(id))
      if (selected) {
        if (keyIndex < 0) this.productPicker.selectedRowKeys.push(id)
        if (productIndex < 0) {
          this.productPicker.selectedProducts.push(record)
        } else {
          this.$set(this.productPicker.selectedProducts, productIndex, {
            ...this.productPicker.selectedProducts[productIndex],
            ...record
          })
        }
      } else {
        if (keyIndex >= 0) this.productPicker.selectedRowKeys.splice(keyIndex, 1)
        if (productIndex >= 0) this.productPicker.selectedProducts.splice(productIndex, 1)
      }
    },
    productRowClassName (record) {
      return this.productPicker.selectedRowKeys.some(key => String(key) === String(record.id)) ? 'product-row-selected' : ''
    },
    confirmProductPicker () {
      if (!this.productPicker.selectedProducts.length) {
        this.$message.warning('请至少选择一个商品 SKU')
        return
      }
      const previousItems = this.form.items.reduce((result, item) => {
        result[String(item.skuId)] = item
        return result
      }, {})
      this.form.items = this.productPicker.selectedProducts.map(product => {
        const previous = previousItems[String(product.id)]
        return {
          ...defaultItem(),
          ...(previous || {}),
          skuId: product.id,
          spuId: product.spuId,
          spuCode: product.spuCode || '',
          spuName: product.spuName || '',
          skuCode: product.skuCode || '',
          skuName: product.skuName || '',
          specName: product.specName || '',
          saleSpec: product.saleSpec || '',
          barcode: product.barcode || '',
          categoryName: product.categoryName || '',
          brandName: product.brandName || '',
          unitId: previous ? previous.unitId : product.baseUnitId,
          unitName: previous ? previous.unitName : (product.baseUnitName || '—')
        }
      })
      this.productPicker.visible = false
      this.form.items.forEach(item => this.loadGuidePrices(item, Boolean(previousItems[String(item.skuId)])))
    },
    onWarehouseChange () {
      this.productPicker.list = []
      this.productPicker.selectedRowKeys = []
      this.productPicker.selectedProducts = []
      if (!this.form.items.length) return
      Promise.all(this.form.items.map(item => this.loadGuidePrices(item))).then(() => {
        const invalidCount = this.form.items.filter(item => item.priceError).length
        if (invalidCount) {
          this.$message.warning(`已按新仓库重新校验定价，${invalidCount} 个 SKU 在该仓无有效指导价，请删除后重新选择`)
        } else {
          this.$message.success('已按新出货仓库重新带出商品价格')
        }
      })
    },
    loadGuidePrices (item, preserveSelection = false) {
      const previousId = preserveSelection ? item.guidePriceId : undefined
      const previousPrice = preserveSelection ? item.salePrice : undefined
      item.priceError = ''
      if (!preserveSelection) {
        item.guidePriceId = undefined
        item.guidePriceName = ''
        item.guidePrices = []
        item.salePrice = undefined
      }
      if (!item.skuId || !this.form.deliveryWarehouseId) return Promise.resolve()
      item.guidePriceLoading = true
      const skuId = item.skuId
      const warehouseId = this.form.deliveryWarehouseId
      return this.fetchGuidePrices(skuId, warehouseId).then(rows => {
        if (String(item.skuId) !== String(skuId) || String(this.form.deliveryWarehouseId) !== String(warehouseId)) return
        item.guidePrices = rows
        if (!rows.length) {
          if (preserveSelection) {
            item.guidePriceId = previousId == null ? undefined : String(previousId)
            item.salePrice = previousPrice == null || previousPrice === '' ? undefined : Number(previousPrice)
          }
          return
        }
        const selected = rows.find(price => String(price.id) === String(previousId))
        const chosen = selected || (preserveSelection ? null : rows[0])
        if (!chosen) {
          item.guidePriceId = previousId == null ? undefined : String(previousId)
          item.salePrice = previousPrice == null || previousPrice === '' ? undefined : Number(previousPrice)
          return
        }
        item.guidePriceId = String(chosen.id)
        this.selectGuidePrice(item)
        if (preserveSelection && Number(previousPrice) > 0) {
          item.salePrice = Number(previousPrice)
        }
      }).finally(() => { item.guidePriceLoading = false })
    },
    guideOptionUnitPrice (price) {
      if (!price) return undefined
      const rate = Number(price.convertRateToBase || 1)
      if (rate > 1 && price.saleUnitGuidePrice != null && price.saleUnitGuidePrice !== '') {
        return price.saleUnitGuidePrice
      }
      return price.guidePrice
    },
    fetchGuidePrices (skuId, warehouseId) {
      const normalize = rows => (rows || []).filter(price => !price.status || price.status === 'enabled')
      return guidePriceOptions(skuId, warehouseId).then(res => {
        const rows = normalize(res.data)
        if (rows.length) return rows
        return listGuidePrice(skuId, warehouseId).then(listRes => normalize(listRes.data))
      }).catch(() => listGuidePrice(skuId, warehouseId).then(listRes => normalize(listRes.data)).catch(() => []))
    },
    selectGuidePrice (item) {
      const selected = item.guidePrices.find(price => String(price.id) === String(item.guidePriceId))
      if (!selected) return
      item.guidePriceName = selected.guidePriceName
      const unitPrice = this.guideOptionUnitPrice(selected)
      item.salePrice = unitPrice == null || unitPrice === '' ? undefined : Number(unitPrice)
      if (selected.saleUnitId) item.unitId = selected.saleUnitId
      if (selected.saleUnitName) item.unitName = selected.saleUnitName
      item.convertRateToBase = Number(selected.convertRateToBase || item.convertRateToBase || 1)
    },
    removeItem (index) {
      this.form.items.splice(index, 1)
    },
    saveForm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (!this.form.items.length) {
          this.$message.error('请从商品档案选择至少一个商品 SKU')
          return
        }
        const invalid = this.form.items.some(item => !item.skuId || !item.skuName || Number(item.qtyOrder || 0) <= 0)
        if (invalid) {
          this.$message.error('请检查商品明细，商品 SKU 和数量必须完整')
          return
        }
        if (Number(this.form.wholeDiscountAmount || 0) > Number(this.totalWithTax)) {
          this.$message.error('整单折扣金额不能大于结算金额')
          return
        }
        const payload = {
          ...this.form,
          freightAmount: this.form.freightAmount == null || this.form.freightAmount === '' ? 0 : this.form.freightAmount,
          expectedDeliveryDate: this.form.expectedDeliveryDate || null,
          items: this.form.items.map(({
            spuCode,
            spuName,
            specName,
            saleSpec,
            barcode,
            categoryName,
            brandName,
            guidePrices,
            guidePriceLoading,
            priceError,
            ...item
          }) => item)
        }
        this.saving = true
        const action = this.form.id ? updateSalesOrder : createSalesOrder
        action(payload).then(() => {
          this.$message.success('保存成功')
          this.drawerVisible = false
          this.loadData()
        }).finally(() => {
          this.saving = false
        })
      })
    },
    handleAudit (record) {
      this.$confirm({
        title: '确认审核',
        content: '审核通过后会占用当前可用库存；若整单库存充足将自动生成并审核销售出库单，否则请手动创建出库单。',
        onOk: () => auditSalesOrder(record.id).then(() => {
          this.$message.success('审核成功')
          this.loadData()
        })
      })
    },
    handleReverseAudit (record) {
      this.$confirm({
        title: '确认反审核',
        content: '反审核会撤销当前订单的审核状态和占用状态。',
        onOk: () => reverseAuditSalesOrder(record.id).then(() => {
          this.$message.success('反审核成功')
          this.loadData()
        })
      })
    },
    handleVoidWhole (record) {
      this.$confirm({
        title: '确认作废',
        content: '作废后，未出库数量将不再支持分批履约；已审核过账的出库数量不受影响。若存在未过账出库单，请先处理。',
        onOk: () => voidWholeSalesOrder(record.id).then(() => {
          this.$message.success('作废成功')
          this.loadData()
        })
      })
    },
    handleDelete (record) {
      this.$confirm({
        title: '确认删除',
        content: `确定删除销售订单「${record.orderNo}」吗？`,
        onOk: () => deleteSalesOrder(record.id).then(() => {
          this.$message.success('删除成功')
          this.loadData()
        })
      })
    },
    lineAmount (item) {
      return this.money(Number(item.qtyOrder || 0) * Number(item.salePrice || 0))
    },
    money (value) {
      return Number(value || 0).toFixed(2)
    },
    displayValue (value) {
      return value === null || value === undefined || value === '' ? '—' : value
    },
    optionLabel (options, value) {
      const option = options.find(item => String(item.value) === String(value))
      return option ? option.label : this.displayValue(value)
    },
    attachmentChanged (value) {
      this.form.attachmentUrl = typeof value === 'string' ? value : (value && (value.attachmentUrl || value.path)) || ''
    },
    attachmentItems (value) {
      return String(value || '').split(',').map(item => item.trim()).filter(Boolean)
    },
    attachmentCount (value) {
      return this.attachmentItems(value).length
    },
    userLabel (id) {
      if (id === null || id === undefined || id === '') return '—'
      const user = this.userOptions.find(item => String(item.id) === String(id))
      return user ? (user.nickName || user.userName) : `用户 #${id}`
    },
    deptLabel (id) {
      if (id === null || id === undefined || id === '') return '—'
      const user = this.userOptions.find(item => item.dept && String(item.dept.id) === String(id))
      return user && user.dept && user.dept.deptName ? user.dept.deptName : `部门 #${id}`
    },
    subjectLabel (id) {
      if (id === null || id === undefined || id === '') return '—'
      return Number(id) === 0 ? '默认经营主体' : `经营主体 #${id}`
    },
    auditText (value) {
      return ({ unaudited: '未审核', audited: '已审核', reverse_audited: '已反审核' })[value] || value || '未审核'
    },
    auditColor (value) {
      return ({ unaudited: 'orange', audited: 'green', reverse_audited: 'blue' })[value] || 'default'
    },
    orderSourceText (value) {
      return value === 'huazhu' ? '华住推送' : '系统创建'
    },
    orderSourceColor (value) {
      return value === 'huazhu' ? 'purple' : 'blue'
    },
    hzText (value) {
      return ({
        warehouse_accepted: '仓库已接单',
        shipped: '已发货',
        signed: '已签收',
        completed: '已完成',
        cancelled: '已取消',
        abnormal: '异常',
        1: '仓库已接单',
        2: '已发货',
        3: '已签收',
        4: '已完成',
        5: '已取消'
      })[value] || '—'
    },
    hzColor (value) {
      return ({
        warehouse_accepted: 'blue',
        shipped: 'orange',
        signed: 'cyan',
        completed: 'green',
        cancelled: 'red',
        abnormal: 'magenta',
        1: 'blue',
        2: 'orange',
        3: 'cyan',
        4: 'green',
        5: 'red'
      })[value] || 'default'
    },
    canOutbound (record) {
      return record
        && record.auditStatus === 'audited'
        && record.voidStatus !== 'voided'
        && record.closeStatus !== 'closed'
        && (record.orderType == null || record.orderType === 'normal_sales')
        && !record.hasOutboundDocument
        && this.outboundStatus(record) === 'none'
    },
    goOutbound (record) {
      this.$router.push({
        path: '/erp/sales-outbound',
        query: { sourceOrderId: String(record.id), outboundAt: String(Date.now()) }
      })
    },
    outboundStatus (record) {
      const status = record && record.executeStatus
      const outbound = Number(record && record.outboundAmount) || 0
      if (status === 'completed') return 'done'
      if (status === 'partial') return 'partial'
      if (status === 'closed') return outbound > 0 ? 'partial' : 'none'
      return 'none'
    },
    outboundText (record) {
      return { done: '已出库', partial: '部分出库', none: '未出库' }[this.outboundStatus(record)]
    },
    outboundColor (record) {
      return { done: 'green', partial: 'orange', none: 'red' }[this.outboundStatus(record)]
    },
    outboundRowClass (record) {
      const status = record && record.hzOrderStatus
      if (status === 'cancelled' || String(status) === '5') return 'order-row-cancelled'
      return ''
    },
    occupyText (value) {
      return ({ not_occupied: '未占用', occupied: '已占用', released: '已释放' })[value] || value || '未占用'
    }
  }
}
</script>

<style scoped>
.sales-order-page{padding:0 0 24px}
.sales-order-page >>> .order-row-cancelled > td{background:#fff1f0}
.search-card,.table-card{background:#fff;border:1px solid #e5e9f0;border-radius:8px;padding:16px 18px;margin-bottom:14px}
.search-card /deep/ .ant-form-item{width:100%;margin-bottom:12px}
.search-card /deep/ .ant-form-item-control-wrapper{width:100%}
.search-actions{display:flex;justify-content:flex-end;gap:8px}
.table-toolbar{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;gap:16px}
.toolbar-actions{display:flex;align-items:center;gap:8px}
.table-toolbar h3{margin:0;font-size:16px;font-weight:700;color:#253142}
.table-toolbar p{margin:4px 0 0;color:#8b96a8;font-size:12px}
.danger-link{color:#f5222d}
.form-section{border:1px solid #e8edf5;border-radius:8px;background:#fff;padding:18px 20px;margin-bottom:14px}
.section-title{display:flex;align-items:center;gap:8px;font-weight:700;color:#253142;margin-bottom:16px}
.section-title:before{content:"";width:7px;height:7px;border-radius:50%;background:#1677ff;box-shadow:0 0 0 4px #e8f2ff}
.section-title.with-action{justify-content:space-between}
.section-title.with-action:before{display:none}
.section-title.with-action > div{display:flex;align-items:baseline;gap:10px}
.section-title.with-action small{color:#8b96a8;font-size:12px;font-weight:400}
.item-table-wrap{overflow:auto;border:1px solid #e3e9f2;border-radius:8px}
.item-table{width:100%;min-width:980px;border-collapse:collapse}
.item-table th{background:#f7f9fc;color:#526071;font-weight:600;text-align:left;padding:10px;border-bottom:1px solid #e3e9f2}
.item-table td{padding:8px 10px;border-bottom:1px solid #edf1f6}
.item-table tr.item-row-error td{background:#fff8f7}
.order-product-cell{min-width:190px}
.order-product-cell strong,.order-product-cell span{display:block}
.order-product-cell strong{color:#253142;font-weight:600}
.order-product-cell span{margin-top:2px;color:#8b96a8;font-size:12px}
.item-price-error{display:block;margin-top:5px;color:#cf1322;font-size:12px;line-height:18px;white-space:nowrap}
.item-price-error .anticon{margin-right:4px}
.item-empty{text-align:center!important;color:#8b96a8;padding:28px 16px!important}
.item-empty .anticon{margin-right:7px;color:#a8b2c1;font-size:16px}
.drawer-footer{position:sticky;bottom:0;z-index:5;margin:0 -24px -24px;padding:14px 24px;background:#fff;border-top:1px solid #e5e9f0;display:flex;justify-content:flex-end;align-items:center;gap:10px}
.total-summary{display:flex;flex-wrap:wrap;gap:8px 20px;margin-right:auto;color:#526071}
.total-summary strong{color:#225fae;font-size:16px;font-variant-numeric:tabular-nums}
.attachment-list{display:grid;gap:7px;min-width:110px}
.customer-picker-panel{border:1px solid #e8edf5;border-radius:8px;background:#f8fbff;padding:12px 14px;margin-bottom:12px}
.customer-picker-search{display:grid;grid-template-columns:minmax(200px,1fr) minmax(260px,1.35fr) auto;gap:14px;align-items:end}
.customer-picker-field{display:grid;gap:6px;margin:0;color:#526071;font-size:12px;font-weight:600}
.customer-picker-field /deep/ .ant-input{height:32px;font-weight:400}
.customer-picker-actions{display:flex;gap:8px}
.customer-picker-actions /deep/ .ant-btn{height:32px}
.customer-picker-tip{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-top:11px;color:#8b96a8;font-size:12px;line-height:20px}
.selected-customer{display:inline-flex;align-items:center;gap:5px;max-width:62%;overflow:hidden;text-overflow:ellipsis;color:#1677ff;background:#edf6ff;border:1px solid #cfe8ff;border-radius:12px;padding:1px 10px;white-space:nowrap}
.customer-picker-modal{max-width:calc(100vw - 32px)}
.customer-picker-modal /deep/ .ant-modal-header{border-bottom:1px solid #edf1f6;padding:16px 20px}
.customer-picker-modal /deep/ .ant-modal-title{font-weight:700;color:#253142}
.customer-picker-modal /deep/ .ant-modal-footer{border-top:1px solid #edf1f6;padding:12px 20px}
.customer-picker-modal /deep/ .ant-table-wrapper{border-radius:8px;overflow:hidden}
.customer-picker-modal /deep/ .ant-table-thead > tr > th{background:#f5f7fb;color:#526071;font-weight:600}
.customer-picker-modal /deep/ .ant-table-tbody > tr{cursor:pointer;transition:background-color .18s ease}
.customer-picker-modal /deep/ .ant-table-tbody > tr:hover > td{background:#f5faff}
.customer-picker-modal /deep/ .ant-table-tbody > tr.customer-row-selected > td{background:#eaf4ff;color:#1f2d3d}
.customer-picker-modal /deep/ .ant-table-tbody > tr.customer-row-selected:hover > td{background:#e1f0ff}
.customer-picker-modal /deep/ .ant-table-scroll .ant-table-body{overflow-x:auto!important}
.customer-picker-modal /deep/ .ant-table-pagination.ant-pagination{margin:12px 0 0}
.customer-code{font-family:Menlo,Consolas,monospace;color:#526071;font-size:12px}
.customer-name{font-weight:600;color:#253142}
.product-picker-panel{border:1px solid #e8edf5;border-radius:8px;background:#f8fbff;padding:12px 14px;margin-bottom:12px}
.product-picker-search{display:grid;grid-template-columns:minmax(360px,1fr) auto;gap:14px;align-items:end}
.product-picker-field{display:grid;gap:6px;margin:0;color:#526071;font-size:12px;font-weight:600}
.product-picker-field /deep/ .ant-input{height:32px;font-weight:400}
.product-picker-actions{display:flex;gap:8px}
.product-picker-actions /deep/ .ant-btn{height:32px}
.product-picker-tip{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-top:11px;color:#8b96a8;font-size:12px;line-height:20px}
.selected-product-count{display:inline-flex;align-items:center;gap:5px;color:#1677ff;background:#edf6ff;border:1px solid #cfe8ff;border-radius:12px;padding:1px 10px;white-space:nowrap}
.product-picker-modal{max-width:calc(100vw - 32px)}
.product-picker-modal /deep/ .ant-modal-header{border-bottom:1px solid #edf1f6;padding:16px 20px}
.product-picker-modal /deep/ .ant-modal-title{font-weight:700;color:#253142}
.product-picker-modal /deep/ .ant-modal-footer{border-top:1px solid #edf1f6;padding:12px 20px}
.product-picker-modal /deep/ .ant-table-wrapper{border-radius:8px;overflow:hidden}
.product-picker-modal /deep/ .ant-table-thead > tr > th{background:#f5f7fb;color:#526071;font-weight:600}
.product-picker-modal /deep/ .ant-table-tbody > tr.product-row-selected > td{background:#eaf4ff}
.product-picker-modal /deep/ .ant-table-scroll .ant-table-body{overflow-x:auto!important}
.picker-product-main strong,.picker-product-main span{display:block}
.picker-product-main strong{color:#253142;font-weight:600}
.picker-product-main span{margin-top:2px;color:#8b96a8;font-family:Menlo,Consolas,monospace;font-size:12px}
@media (max-width: 760px){
  .customer-picker-search{grid-template-columns:1fr}
  .customer-picker-actions{justify-content:flex-end}
  .customer-picker-tip{align-items:flex-start;flex-direction:column}
  .selected-customer{max-width:100%}
  .product-picker-search{grid-template-columns:1fr}
  .product-picker-actions{justify-content:flex-end}
  .product-picker-tip{align-items:flex-start;flex-direction:column}
}
</style>
